import { ResourceOptions } from 'react-admin';
import { FaBroadcastTower } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingSignals;
export const icon = FaBroadcastTower;
export const options: ResourceOptions = {
  label: 'module.socialTrading.signals',
};
